import { CherryMascot } from './CherryMascot';

interface EmptyStateProps {
  variant: 'search' | 'empty' | 'success' | 'error';
  title: string;
  description?: string;
  action?: { label: string; onClick: () => void };
}

const variantToMood = {
  search: 'searching',
  empty: 'default',
  success: 'happy',
  error: 'error',
} as const;

export function EmptyState({ variant, title, description, action }: EmptyStateProps) {
  return (
    <div className="text-center py-12 px-4">
      <div className="mb-4">
        <CherryMascot mood={variantToMood[variant]} size={80} className="inline-block" />
      </div>
      <p className="text-base font-medium text-text-primary mb-1">{title}</p>
      {description && (
        <p className="text-sm text-text-muted mb-4">{description}</p>
      )}
      {action && (
        <button
          onClick={action.onClick}
          className="px-4 py-2 bg-cherry-500 hover:bg-cherry-600 text-white text-sm font-medium rounded-lg transition-colors"
        >
          {action.label}
        </button>
      )}
    </div>
  );
}
